<template>
  <div>
    {{ title }}
    <v-stepper>
      <v-stepper-header v-if="steps && steps.length">
        <div v-for="(currentStep, index) in steps" :key="index">
          <v-stepper-step
            step=""
            :complete="checkStepCompletion(currentStep, index)"
          >
            {{ currentStep.orderStatus }} <br />
            <small>{{ getStepSub(currentStep, index) }}</small>
            <v-divider v-if="timeline.length > Number(index)"></v-divider>
          </v-stepper-step>
        </div>
      </v-stepper-header>
    </v-stepper>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    timeline: {
      type: Array,
    },
    title: {
      type: String,
      default: "",
    },
  },
  computed: {
    steps() {
      const { timeline } = this;
      const hasCompletion = timeline.find(
        (step) => step.orderStatus === "Completed"
      );
      if (hasCompletion) {
        return timeline;
      } else {
        return [...timeline, { orderStatus: "Completed" }];
      }
    },
  },
  methods: {
    getStepName(currentStep, index) {
      const { orderStatus, date } = currentStep;
      return orderStatus;
    },
    checkStepCompletion(currentStep, index) {
      const { orderStatus, date } = currentStep;
      return !(orderStatus === "Completed" && !date);
    },
    getStepSub(currentStep, index) {
      const { orderStatus, date } = currentStep;
      if (orderStatus === "Completed") {
        if (date) {
          return `Completed on ${moment(date).format("MM-DD-YYYY")}`;
        }
      }

      if (date) {
        if (orderStatus === "Completed") {
          return `Completed on ${moment(date).format("MM-DD-YYYY")}`;
        } else {
          return `Order ETA ${moment(date).format("MM-DD-YYYY")}`;
        }
      }
    },
    getIcon(currentStep, index) {
      if (currentStep === "Pending") {
        return "notification_important";
      } else if (currentStep === "Submitted") {
        return "schedule";
      } else if (currentStep === "Confirmed") {
        return "thumb_up";
      } else if (currentStep === "Completed") {
        return "complete";
      }
    },
  },
};
</script>
